import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './project.types';

export const projectSelectors = {
  ...generateResourceSelectors<types.IProject>((state) => state.resource.project),
};
